const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://zacharytoliver.com',
  title: 'ZT.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Zachary Toliver',
  role: 'Full-Stack Software Developer',
  description:
    "I am a seasoned technology expert boasting a dynamic eight-year track record in spearheading transformative technical projects and crafting cutting-edge software solutions. My unwavering commitment to excellence is underpinned by a formidable blend of technical prowess, creative problem-solving acumen, and inspirational leadership capabilities. Throughout my journey, I've consistently driven growth and streamlined maintenance processes across various domains. My leadership style hinges on building trust-infused partnerships and leading through the power of example. I'm adept at harnessing all available resources and state-of-the-art tools to drive project fruition and business triumph, fostering an environment of peak efficiency and unwavering success across IT business functions.",
  resume: 'https://zacharytoliver.com/resume',
}

const educationList = [
  {
    degree: 'B.B.A. in Computer Information Systems',
    school: 'Texas State University',
    location: 'San Marcos, Texas',
    startDate: 'August 2010',
    endDate: 'December 2014',
    overview: 'The mission of the Department of Computer Information Systems and Quantitative Methods is to provide optimal educational opportunities to students wishing to pursue professional careers in Information Systems, Information Technology, and Decision Sciences.',
    skillsAcquired: [
      'Business Management',
      'Software Development Life Cycle', 
      'Programming Foundations', 
      'Entrepreneurship', 
      'Database Management', 
      'Project Management'
    ]
  }
]

const jobs = [
  {
    title: 'Senior Manager, Software Engineering',
    company: 'Dell Technologies',
    location: 'Round Rock, Texas (Hybrid)',
    startDate: 'March 2024',
    endDate: 'Present',
    overview: 'Lead multiple engineering teams within the Customer Data organization, aligning technical strategy and execution with enterprise-wide business objectives. Oversee the delivery of complex, high-impact initiatives by defining program vision, architectural direction, scope, resource allocation, and budget planning across teams. Serve as a subject matter expert for critical data platforms and systems, partnering with cross-functional stakeholders to translate key performance indicators and customer success factors into scalable, secure, and reliable solutions. Invest in leadership development and career growth for managers and engineers, cultivating a culture of accountability, technical excellence, and continuous improvement.',
    skillsAcquired: [          
      'Engineering Leadership',
      'Technical Strategy',
      'Program Delivery',
      'Artificial Intelligence and Agentic Systems'
    ],
    roles: [
      {
        title: 'Senior Manager, Software Engineering',
        company: 'Dell Technologies',
        location: 'Round Rock, Texas (Hybrid)',
        startDate: 'March 2024',
        endDate: 'Present',
        overview: 'Lead multiple engineering teams within the Customer Data organization, aligning technical strategy and execution with enterprise-wide business objectives. Oversee the delivery of complex, high-impact initiatives by defining program vision, architectural direction, scope, resource allocation, and budget planning across teams. Serve as a subject matter expert for critical data platforms and systems, partnering with cross-functional stakeholders to translate key performance indicators and customer success factors into scalable, secure, and reliable solutions. Invest in leadership development and career growth for managers and engineers, cultivating a culture of accountability, technical excellence, and continuous improvement.',
        skillsAcquired: [
          'Engineering Leadership',
          'Technical Strategy',
          'Program Delivery',
          'Artificial Intelligence and Agentic Systems'
        ],
      },
      {
        title: 'Principal Software Engineer',
        company: 'Dell Technologies',
        location: 'Round Rock, Texas',
        startDate: 'September 2018',
        endDate: 'March 2024',
        overview: 'Lead Pivotal organization-wide engineering and cultural transformation by working closely with various teams to adopt Agile & Extreme Programming methodologies. Give users of our products an equal voice by advocating for them using User-Centered Design within our balanced teams and products. Discover the needs of our customers and employees and frame solutions to deliver value to them quickly. Offer proposed design suggestions to processes and applications and exert latitude in determining objectives of an assignment.',
        skillsAcquired: [
          'Extreme Programming',
          'Lean Product Development',
          'Cloud-Native Applications',
          'Test-Driven Development'  
        ],
      },
      {
        title: 'Senior Software Engineer',
        company: 'Dell Technologies',
        location: 'Round Rock, Texas',
        startDate: 'April 2016',
        endDate: 'September 2018',
        overview: 'A Dell Software Engineer is responsible for writing well designed, testable, and efficient C# code as well as integrating software components into a fully functional software system. This role also includes confering with systems analysts, engineers, stakeholders and others to design systems and to obtain information on project limitations and capabilities, performance, requirements and interfaces.',
        skillsAcquired: [
          'C# Programming',
          'Requirements Gathering and Analysis',
          'Agile Methodology',
          'HTML/CSS/JS',
          'Bootstrap',
          'KnockoutJS',
          'Elasticsearch',
          'SDLC'
        ]
      }
    ]
  },
  {
    title: 'Consultant',
    company: 'Sogeti USA',
    location: 'Austin, Texas',
    startDate: 'January 2015',
    endDate: 'April 2016',
    overview: 'A Dell Software Engineer is responsible for writing well designed, testable, and efficient C# code as well as integrating software components into a fully functional software system. This role also includes confering with systems analysts, engineers, stakeholders and others to design systems and to obtain information on project limitations and capabilities, performance, requirements and interfaces.',
    skillsAcquired: [
      'C# Programming',
      'Automated Functional and API Testing',
      'Requirements Analysis',
      'Agile Methodology',
      'JIRA',
      'HTML/CSS/JS',
      'Bootstrap',
      'Manual Testing',
      'SharePoint Development',
      'Mobile Device Testing'
    ],
    roles: [
      {
        title: 'Consultant',
        company: 'Sogeti USA',
        location: 'Austin, Texas',
        startDate: 'January 2015',
        endDate: 'April 2016',
        overview: 'A Dell Software Engineer is responsible for writing well designed, testable, and efficient C# code as well as integrating software components into a fully functional software system. This role also includes confering with systems analysts, engineers, stakeholders and others to design systems and to obtain information on project limitations and capabilities, performance, requirements and interfaces.',
        skillsAcquired: [
          'C# Programming',
          'Automated Functional and API Testing',
          'Requirements Analysis',
          'Agile Methodology',
          'JIRA',
          'HTML/CSS/JS',
          'Bootstrap',
          'Manual Testing',
          'SharePoint Development',
          'Mobile Device Testing'
        ],
        roles: [
        ]
      }
    ]
  }
]

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Project 1',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
  {
    name: 'Project 2',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
  {
    name: 'Project 3',
    description:
      'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['SASS', 'TypeScript', 'React'],
    sourceCode: 'https://github.com',
    livePreview: 'https://github.com',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'C#',
  '.Net Core',
  'Elasticsearch',
  'TigerGraph',
  'HTML',
  'CSS',
  'JavaScript',
  'TypeScript',
  'React',
  'Material UI',
  'Git',
  'CI/CD',
]

const tools = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Postman', 
  'GitLab',
  'Cloud Foundry',
  'Visual Studio',
  'Octopus Deploy',
  'TeamCity',
  'Jira',
  'Postman',
  'Github',
  'Team Foundation Server',
  'Chrome DevTools',
  'SOAP UI',
  'Fiddler',
  'Kibana'
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  emailCipher: {
    key: 73,
    data: [44, 36, 40, 32, 37, 9, 51, 40, 42, 33, 40, 59, 48, 61, 38, 37, 32, 63, 44, 59, 103, 42, 38, 36],
  },
  linkedin: 'https://www.linkedin.com/in/zacharystoliver/',
  github: 'https://github.com/ztoliver',
}

export { header, about, educationList, projects, jobs, skills, tools, contact }
